import axios from "axios";
import { API_ENDPOINTS } from "../ApiEndPoints";

const newsLetterUrl = `${process.env.REACT_APP_API_URL}${API_ENDPOINTS.NEWS_LETTER}`;

// Function to submit the newsletter email
export const submitNewsLetter = async (email) => {
  try {
    const response = await axios.post(newsLetterUrl, { email });
    return response.data; // Return the response data, could be a success message or user data
  } catch (error) {
    console.error("Error submitting newsletter:", error);
    throw error; // Propagate the error if needed
  }
};
